module.exports = __webpack_public_path__ + "img/menu_car.e41a2727.png";